export default "__VITE_ASSET__6b8089d2__"